export function debounce<Args extends any[]>(fn: (...args: Args) => any, interval: number) {
	let timeoutId = 0;

	function debounceTrigger(...args: Args) {
		if (timeoutId) {
			clearTimeout(timeoutId);
		}

		timeoutId = window.setTimeout(() => {
			fn(...args);
			timeoutId = 0;
		}, interval);
	}

	debounceTrigger.cancel = () => {
		clearTimeout(timeoutId);
	};

	debounceTrigger.pending = () => {
		return timeoutId === 0;
	};

	return debounceTrigger;
}
